import useBanners from './useBanners'

export default useBanners
